<template>
  <DefaultLayout :disableFacilitatorTools="true">
    <div class="text-center">
          <h4>{{ $t("title") }}</h4>
    </div>

    <card shadow>
      <span v-html="$t('instructions')"/>
    </card>

    <template v-if="canCreateNewSimulation">
      <base-button @click="createNew()" type="success" size="lg" style="margin: 5px">{{$t('create-new-simulation')}}</base-button>
    </template>
    <template v-else>
      <strong>{{$t('max-number-reached')}}</strong>
    </template>

    <base-button
      size="sm"
      type="primary"
      style="white-space: normal; margin: 2px"
      v-on:click="$router.push('/admin/games/')"
      >{{ $t('exit') }}
    </base-button>    

    <br/>
    <br/>

    <EditorScenarioList v-if="rpsScenarios.length"/>

    <base-button
      size="sm"
      type="primary"
      style="white-space: normal; margin: 2px"
      v-on:click="$router.push('/admin/games/')"
      >{{ $t('exit') }}
    </base-button>    

  </DefaultLayout>
</template>

<script>
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import EditorScenarioList from "@/components/EditorScenarioList.vue";

import { getRPSScenarios, } from "@/services/APIService";

export default {
  components: {
    DefaultLayout, EditorScenarioList,
  }, 
  data() {
    return {
      rpsScenarios: [],
    };
  },
  computed: {
    canCreateNewSimulation() {
      const ids = [];

      for (let i = 0; i < this.rpsScenarios.length; i++) {
        ids.push(this.rpsScenarios[i].rps_scenario_id);
      }

      const unique = [...new Set(ids)];

      if (unique.length < 100) {
        return true;
      } else {
        return false;
      }

      // Later this could be enforced also in the backend.
      // Not happening at the moment
    },
  },
  mounted() {
    // Editor is now available only in two locales:
    this.$store.commit({
        type: "setUILocales",
        locales: ["en", "fi"]
    });

    this.populateScenarios();
  },
  methods: {
    createNew() {
      this.$router.push("/admin/scenarioeditor/new")
    },
    populateScenarios() {
      getRPSScenarios(true).then((rpsScenarios) => {
        this.rpsScenarios = rpsScenarios;
      });
    }
  },
};
</script>

<i18n>
  {
    "en": {
      "select-scenario": "Select simulation you want to edit:",
      "instructions": "<strong>How to create a simulation:</strong><br/>1. Create a new simulation<br/>2. Add photos for the simulation<br/>3. Use practice games to check everything is ok.<br/>4. When the simulation is finished, publish it. Before the simulation is published it can be used only by yourself and other facilitators in your organization who have access to the simulation editor. Simulations made using the editor can always be accessed only by facilitators of the same organization.<br/><br/>Please note that simulations cannot be deleted, but you can unpublish a simulation.<br/><br/>Editing a simulation after it has already been played does not affect reports of those games.",
      "create-new-simulation": "Create a new simulation",
      "exit": "Exit editor",
      "max-number-reached": "You have reached the maximum number of custom simulations (100).",
      "title": "Simulation editor"
    },
    "fi": {
      "select-scenario": "Valitse simulaatiota, jota haluat muokata:",
      "instructions": "<strong>Näin teet uuden simulaation:</strong><br/>1. Luo uusi simulaatio<br/>2. Lisää simulaatioon kuvat<br/>3. Hyödyntämällä harjoituspelejä voit tarkistaa, että kaikki on kunnossa.<br/>4. Kun simulaatio on valmis, julkaise se. Ennen julkaisemista simulaatiota voivat hyödyntää lisäksesi vain pelinjohtajat, joilla on simulaatioiden muokkausoikeudet. Itse muokatut simulaatiot on aina rajattu vain saman organisaation pelinjohtajille.<br/><br/>Luotua simulaatiota ei voi tuhota, mutta voit poistaa sen julkaisun koska tahansa.<br/><br/>Jos muokkaat myöhemmin simulaatiota, jota on jo käytetty peleissä, muokkaukset eivät vaikuta näiden pelien raportteihin.",
      "create-new-simulation": "Luo uusi simulaatio",
      "exit": "Poistu editorista",
      "max-number-reached": "Olet luonut sallitun enimmäismäärän simulaatioita (100).",
      "title": "Simulaatioeditori"
    }
  }
  </i18n>
